import config, { config2 } from "../../../config";
import Moment from "moment";
import $ from "jquery";
import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./style.css";
import Pagination from "../../../components/Pagination";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import deleteIcon from "../../../images/icons/delete.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import viewIcon from "../../../images/icons/view.png";
import editIcon from "../../../images/icons/edit.png";
import resendIcon from "../../../images/icons/resend.png";
import Swal from "sweetalert2";
import moment from "moment";

import filter from "../../../images/icons/filter.png";
import DateRangeFilter from "../../../components/DateRangeFilter";
import { millionComma } from "../../../utils";
import { formatStatusBadge } from "../util";
import {
  formatAmountChallan,
  formatAmountChallanRtn,
} from "../../Purchase/util";
import { ConfigContext } from "../../../App";
import { FcApproval } from "react-icons/fc";
import { FaInfoCircle } from "react-icons/fa";

function ChallanRtnList(props) {
  const [user, setUser] = useState({});

  const location = useLocation();
  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const initialState = {
    challan_no: "",
    challan_id: "",
    customer_name: "",
    branch_name: "",
    branch_id: "",
    from_date: "",
    to_date: "",
    is_active: "",
    sync_status: "",
  };

  let newFilter = location.state?.appliedFilter || initialState;
  let newFilterVisiblity = location.state?.filterDisplay;
  let backToCurrPage = location.state?.backToCurrent;

  const [formInputs, setFormInputs] = useState(newFilter);
  const [filtersVisible, setFiltersVisible] = useState(
    newFilterVisiblity === true ? true : false,
  );
  const [filterActive, setFilterActive] = useState(
    location.state?.appliedFilter ? true : false,
  );
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    backToCurrPage ? backToCurrPage : 1,
  );
  const [totalPage, setTotalPage] = useState(0);
  const [filterDate, setFilterDate] = useState();
  const initialPageSize = location.state?.pageSize || 10;
  const [userCount, setUserCount] = useState(initialPageSize);
  const loginBranch = useContext(ConfigContext)?.loginBranch;
  const erpIntegration = useContext(ConfigContext)?.erpIntegration;
  const [isErpLoading, setIsErpLoading] = useState(false);
  let dates = filterDate && JSON.parse(filterDate.date);

  function handleInputDate(e) {
    setFilterDate((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  }

  function toggleItemDetail(id) {
    $(`#${id}`).is(":visible")
      ? $(`#${id}`).addClass("d-none")
      : $(`#${id}`).removeClass("d-none");
  }

  function changeStatus(challan_rtn_id, is_active) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;
    confirmAlert({
      message: `You want to ${is_active == 3 ? "unfreeze" : "cancel"} challan.`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            setActionLoading(challan_rtn_id);
            $.post(
              `${config.apiUrl}/challanRtn/cancelChallanRtn`,
              JSON.stringify({
                branch_id,
                challan_rtn_id,
                is_active,
              }),
            )
              .done(function (res) {
                setActionLoading(null);
                getList(filtersVisible);
                setError("");
                setSuccess(res?.data?.message);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setActionLoading(null);
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                  err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }
  function ApprovedBranch(challan_rtn_id) {
    let branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData
      ?.branch_data?.[0]?.branch_id;

    confirmAlert({
      title: "Are you sure?",
      message: `You want to approve challan Return`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            setActionLoading(challan_rtn_id);
            $.post(
              `${config.apiUrl}/challanRtn/manualAutoApprove`,
              JSON.stringify({ challan_rtn_id: challan_rtn_id }),
            )
              .done(function (res) {
                setActionLoading(null);
                getList(filtersVisible);
                setError("");
                console.log("sjgsdshdjsjdks", res?.data);
                setSuccess(res?.data);
                setTimeout(function () {
                  setSuccess("");
                }, 4000);
              })
              .catch(function (err) {
                setActionLoading(null);
                setSuccess("");
                setError(
                  err?.responseJSON?.data?.message ||
                  err?.responseJSON?.message,
                );
                setTimeout(function () {
                  setError("");
                }, 4000);
              });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  }

  async function getList(isFilter = true, pageNo = null, perPage = userCount) {
    let json = {
      paginate: 1,
      list_type: 3,
      page_no: (pageNo || currentPage) - 1,
      branch_id: JSON.parse(localStorage.getItem("inventory"))?.userData
        ?.branch_data?.[0]?.branch_id,
    };
    if (isFilter) {
      // if (dates) {
      //   formInputs.from_date = dates[0];
      //   formInputs.to_date = dates[1];
      // }
      json = {
        ...json,
        ...formInputs,
        list_type: 3,
        branch_id:
          JSON.parse(localStorage.getItem("inventory"))?.userData
            ?.branch_data?.[0]?.branch_id || formInputs.branch_id,
      };
    }
    json.page_size = perPage;
    await $.post(
      `${config2.apiUrl}/challanRtn/listChallanRtn`,
      JSON.stringify(json),
    )
      .done(function (res) {
        setCurrentPage(pageNo || currentPage);
        setList(res?.data?.list || []);
        setTotalPage(res?.data?.count || 0);
        setIsLoading(false);
        setIsSubmit(false);
      })
      .catch(function (err) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err?.responseJSON?.data?.message || err?.responseJSON?.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsSubmit(false);
      });
  }

  useEffect(
    function () {
      getList(filterActive);
    },
    [currentPage],
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }

  const [exportIds, setExportIds] = useState([]);
  const [isExport, setIsExport] = useState(false);
  const getExportIds = (e) => {
    if (e.target.value == "All") {
      if (e.target.checked) {
        // if (
        //   moment(formInputs.challan_date).format("MM-DD-yy") >=
        //   moment().format("MM-DD-yy")
        // ) {
        //   setExportIds((prevState) => [
        //     ...prevState,
        //     ...list.map((v) =>
        //       v.is_active == 4 ||
        //       v.is_active == 3 ||
        //       v.is_active == 2 ||
        //       v.is_active == 6
        //         ? v.challan_rtn_id
        //         : ""
        //     ),
        //   ]);
        // } else {
        //   setExportIds((prevState) => [
        //     ...prevState,
        //     ...list.map((v) => (v.is_active == 4 ? v.challan_rtn_id : "")),
        //   ]);
        // }
        // setExportIds((prevState) => [
        //   ...prevState,
        //   ...list.map((v) => v.challan_rtn_id),
        // ]);
        setExportIds((prevState) => [
          ...prevState,
          ...list.filter((v) => v.is_active == 4).map((v) => v.challan_rtn_id),
        ]);
      } else {
        setExportIds(() => []);
      }
    } else {
      const val = e.target.value;
      if (e.target.checked) {
        setExportIds((prevState) => [...prevState, val.match(/^\d+$/) ? Number(val) : val]);
      } else {
        setExportIds((prevState) =>
          prevState.filter((v) => v != val),
        );
      }
    }
  };

  const downloadExportJson = async () => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one challan Return");
      return;
    }
    let branch_id =
      JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]
        ?.branch_id || formInputs.branch_id;
    setIsExport(true);
    await $.post(
      `${config.apiUrl}/challanRtn/exportChallanReturn`,
      JSON.stringify({
        challan_rtn_ids: exportIds,
        branch_id: branch_id,
      }),
    )
      .done(function (res) {
        const jsonData = new Blob([JSON.stringify(res, null, 3)], {
          type: "text/json",
        });
        const jsonURL = window.URL.createObjectURL(jsonData);
        const link = document.createElement("a");
        document.body.appendChild(link);
        link.href = jsonURL;
        link.setAttribute("download", "Challan-Return.json");
        link.click();
        document.body.removeChild(link);
        setIsExport(false);
        getList(filterActive);
      })
      .catch(function (err) {
        setIsExport(false);
        Swal.fire(
          "Error",
          err?.responseJSON?.data?.message || err?.responseJSON?.message,
        );
      });
  };

  const sendERP = async (type = "ERP") => {
    if (exportIds.length == 0) {
      Swal.fire("", "Select atleast one challan Return");
      return;
    }

    const selectedItems = list.filter((x) => exportIds.includes(x.challan_rtn_id));
    const alreadySynced = selectedItems.filter((x) => x.sync_status == 1);

    if (alreadySynced.length > 0) {
      const nos = alreadySynced.map((x) => x.challan_rtn_no || x.challan_no).join(", ");
      Swal.fire({
        icon: "warning",
        title: "Already synced",
        text: `Challan Return no ${nos} are already synced successfully. Please untick them first and then Send to ERP.`,
        confirmButtonText: "OK",
      });
      return;
    }

    setIsErpLoading(true);
    await $.post(
      `${config.apiUrl}/challanRtn/updateErpStatus`,
      JSON.stringify({
        challan_rtn_ids: exportIds,
        challan_ids: exportIds,
        is_erp: 1,
        type: type,
      }),
    )
      .done(function (res) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "success",
          title: "Success",
          text:
            res?.data?.message ||
            (type === "NON-ERP"
              ? "Challan Return successfully marked for Non ERP."
              : "Challan Return successfully sent to ERP."),
        });
        getList(filterActive);
      })
      .catch(function (err) {
        setIsErpLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            err?.responseJSON?.data?.message ||
            err?.responseJSON?.message ||
            "Something went wrong while sending to ERP",
        });
      });
  };

  const changePageSize = async (e) => {
    setUserCount(() => e.target.value);
    // setFormInputs((prevState) => {
    //   return { ...prevState, page_size: e.target.value };
    // });
    if (list.length > 0) {
      currentPage == 1
        ? await getList(
          {
            ...formInputs,
            // page_size: e.target.value,
          },
          null,
          e.target.value,
        )
        : setCurrentPage(() => 1);
    }
  };

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-2" id="sale">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Challan Return"]} />
                </div>
                <div className="col text-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  {/* {user?.role_id === 3 && (
                    <>
                      <Link
                        to="/challanRtn/add"
                        className="btn btn-primary px-4 py-2">
                        New Challan Return
                      </Link>
                    </>
                  )} */}
                  <span className=" me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => changePageSize(e)}
                      className="custom-select"
                      style={{ height: "32px" }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  {user.role_id !== 2 ? (
                    <Link
                      to="/challanRtn/add"
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        float: "right",
                      }}
                    >
                      New Challan Return
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    setFilterActive(true);

                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1);
                  }}
                  id="saleReturnAdd"
                  className="my-3"
                  autoComplete="off"
                >
                  <div className="row g-3 mb-2">
                    <div className="col-md">
                      <label htmlFor="challan_rtn_no">Challan Return No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="challan_rtn_no"
                        value={formInputs.challan_rtn_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="challan_no">Challan No</label>
                      <input
                        type="text"
                        className="form-control"
                        id="challan_no"
                        value={formInputs.challan_no}
                        onChange={handleInputs}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="customer_name">Customer Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="customer_name"
                        value={formInputs.customer_name}
                        onChange={handleInputs}
                      />
                    </div>
                    {/* <DateRangeFilter
                      filterDate={filterDate}
                      onChange={handleInputDate}
                    /> */}
                    <div className="col-md">
                      <label htmlFor="from_date">From Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="from_date"
                        value={formInputs.from_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    <div className="col-md">
                      <label htmlFor="to_date">To Date</label>
                      <input
                        type="date"
                        className="form-control"
                        id="to_date"
                        value={formInputs.to_date}
                        onChange={handleInputs}
                        max={moment().format("YYYY-MM-DD")}
                      />
                    </div>
                    {user.role_id != 3 && user.role_id != 4 && (
                      <div className="col-md">
                        <label htmlFor="branch_id">Branch</label>
                        <select
                          className="form-select"
                          id="branch_id"
                          name="branch_id"
                          value={formInputs.branch_id}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              branch_id: e.target.value,
                            })
                          }
                        >
                          <option value={""}>select...</option>
                          {props.branchList.map((v, i) => (
                            <option key={i} value={v.value}>
                              {v.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}
                    <div className="col-md">
                      <label htmlFor="is_active">Status</label>
                      <select
                        className="form-select"
                        id="is_active"
                        name="is_active"
                        value={formInputs.is_active}
                        onChange={(e) =>
                          setFormInputs({
                            ...formInputs,
                            is_active: e.target.value,
                          })
                        }
                      >
                        {[
                          { id: "", name: "All" },
                          { id: 1, name: "New" },
                          { id: 4, name: "Issued" },
                          { id: 2, name: "partial Done" },
                          {
                            id: 5,
                            name: "Cancelled",
                          },
                        ].map((v, i) => (
                          <option
                            key={i}
                            value={v.id}
                          // className={v.id === 0 ? "bg-lightgrey" : ""}
                          >
                            {v.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {erpIntegration == 1 ? (
                      <div className="col-md">
                        <label htmlFor="sync_status">Sync Status</label>
                        <select
                          className="form-select"
                          id="sync_status"
                          name="sync_status"
                          value={formInputs.sync_status}
                          onChange={(e) =>
                            setFormInputs({
                              ...formInputs,
                              sync_status: e.target.value,
                            })
                          }
                        >
                          {[
                            { id: "", name: "All" },
                            { id: 0, name: "Pending" },
                            { id: 1, name: "Success" },
                            { id: 2, name: "Failed" },
                          ].map((v, i) => (
                            <option
                              key={i}
                              value={v.id}
                              className={v.id === 0 ? "bg-lightgrey" : ""}
                            >
                              {v.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : null}
                  </div>
                  <div className="row mt-3">
                    <div
                      className="col-md"
                      style={{ display: "flex", alignItems: "end" }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2 text-white"
                        type="reset"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setFilterDate();
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        Clear Filters
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary py-0 ms-2"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "#ffffff",
                        }}
                        onClick={downloadExportJson}
                      >
                        {isExport && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Export
                      </button>
                      {erpIntegration == 1 ? (
                        <div className="btn-group ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{
                              background: "#4263eb",
                              borderColor: "#4263eb",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              fontWeight: "600",
                              fontSize: "14px",
                              height: "35px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              color: "#ffffff",
                              whiteSpace: "nowrap",
                            }}
                            onClick={() => sendERP("ERP")}
                            disabled={isErpLoading}
                          >
                            {isErpLoading && (
                              <span className="spinner-border spinner-border-sm me-2"></span>
                            )}
                            Mark For ERP
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle dropdown-toggle-split"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            disabled={isErpLoading}
                            style={{
                              background: "#3b5bdb",
                              borderColor: "#3b5bdb",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              height: "35px",
                              color: "#ffffff",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            <span className="visually-hidden">Toggle Dropdown</span>
                          </button>
                          <ul
                            className="dropdown-menu dropdown-menu-end shadow"
                            style={{ minWidth: "160px", zIndex: 1050 }}
                          >
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("ERP")}
                              >
                                Mark For ERP
                              </button>
                            </li>
                            <li>
                              <button
                                type="button"
                                className="dropdown-item py-2 fw-semibold"
                                onClick={() => sendERP("NON-ERP")}
                              >
                                Mark For Non ERP
                              </button>
                            </li>
                          </ul>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </form>
              )}

              {(error || success) && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-${error ? "danger" : "success"
                        } py-1 small`}
                      role="alert"
                    >
                      {error || success || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col table-responsive-lg">
                  <table
                    className={`table ${error || success ? "my-1" : "mt-4"
                      } rounded`}
                  >
                    <thead>
                      <tr>
                        <th>
                          <input
                            type="checkbox"
                            id="All"
                            value="All"
                            onChange={(e) => getExportIds(e)}
                          />
                        </th>
                        <th>Challan Return No</th>
                        <th>Challan No</th>
                        <th>Customer Name</th>
                        {user.role_id != 3 && user.role_id != 4 && (
                          <th>Branch Name</th>
                        )}
                        <th className="text-end">Amount</th>
                        <th> Date</th>
                        <th className="text-end">Export Count</th>
                        <th>Status</th>
                        {erpIntegration == 1 ? <th>Sync Status</th> : null}
                        <th style={{ width: "140px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length === 0) && (
                        <tr>
                          <td colSpan={erpIntegration == 1 ? "11" : "10"} className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list &&
                        list.map((v, i) => (
                          <>
                            <tr
                              key={`sl_` + i}
                              // className={v.is_active ? "" : "bg-lightgrey"}
                              className={
                                v?.export_count > 0
                                  ? ""
                                  : v.is_active
                                    ? ""
                                    : "bg-lightgrey"
                              }
                              style={
                                v?.export_count > 0
                                  ? {
                                    backgroundColor: `rgba(var(--theme-btn-color-rgb, 13, 202, 240), ${Math.min(
                                      v?.export_count * 0.15,
                                      1,
                                    )})`,
                                  }
                                  : {}
                              }
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  value={v?.challan_rtn_id}
                                  checked={exportIds.includes(
                                    v?.challan_rtn_id,
                                  )}
                                  //   className={`${
                                  //     moment(v.challan_date).format("MM-DD-yy") >=
                                  //       moment().format("MM-DD-yy") &&
                                  //     (v?.is_active == 1 ||
                                  //       v?.is_active == 2 ||
                                  //       v?.is_active == 3 ||
                                  //       v.is_active == 5 ||
                                  //       v.is_active == 6)
                                  //       ? "d-none"
                                  //       : ""
                                  //   }`}
                                  className={`${v?.is_active == 1 ||
                                    v?.is_active == 2 ||
                                    v?.is_active == 3 ||
                                    v.is_active == 5 ||
                                    v.is_active == 6
                                    ? "d-none"
                                    : ""
                                    }`}
                                  onChange={(e) => getExportIds(e)}
                                />
                              </td>
                              <td>
                                <span
                                // className="link-primary user-select-none"
                                // role="button"
                                // onClick={() => toggleItemDetail(`sli_${i}`)}
                                >
                                  {v.challan_rtn_no}
                                </span>
                              </td>
                              <td>{v.challan_no}</td>
                              <td>
                                <span title={v.mst_cust.customer_name}>
                                  {v.mst_cust.customer_name.length > 15
                                    ? v.mst_cust.customer_name
                                      .toString()
                                      .substring(0, 15) + "..."
                                    : v.mst_cust.customer_name}
                                </span>
                              </td>
                              {user.role_id != 3 && user.role_id != 4 && (
                                <td>{v?.mst_branch?.branch_name}</td>
                              )}

                              <td className="text-end">
                                {millionComma(v?.total_amount || 0)}
                              </td>
                              <td>
                                {Moment(v.trans_date, "YYYY-MM-DD").format(
                                  "DD-MM-YYYY",
                                )}
                              </td>
                              <td className="text-end">
                                {v?.export_count || "0"}
                              </td>
                              <td className="">{formatStatusBadge(v)}</td>
                              {erpIntegration == 1 && (
                                <td>
                                  {v.is_erp == 1
                                    ? (() => {
                                      const status = v?.sync_status;

                                      if (status === 0) {
                                        return (
                                          <span
                                            className="badge bg-warning"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Pending
                                          </span>
                                        );
                                      }

                                      if (status === 1) {
                                        return (
                                          <span
                                            className="badge bg-success"
                                            style={{ fontSize: "11px" }}
                                          >
                                            Success
                                          </span>
                                        );
                                      }

                                      if (status === 2) {
                                        return (
                                          <>
                                            <span
                                              className="badge bg-danger"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Failed
                                            </span>

                                            <Tippy
                                              content={
                                                v?.sync_err || "Sync Error"
                                              }
                                            >
                                              <span
                                                style={{ cursor: "pointer" }}
                                              >
                                                <FaInfoCircle
                                                  style={{
                                                    fontSize: "15px",
                                                    marginLeft: "5px",
                                                  }}
                                                />
                                              </span>
                                            </Tippy>
                                          </>
                                        );
                                      }

                                      return (
                                        <span className="text-muted">-</span>
                                      );
                                    })()
                                    : "NA"}
                                </td>
                              )}
                              <td>
                                <Tippy content="View">
                                  <Link
                                    to={`/challanRtn/view/` + v.challan_rtn_id}
                                    state={{
                                      sale: v,
                                      currentPageNo: currentPage,
                                      currentFilter: formInputs,
                                      showFilter: filtersVisible,
                                      pageSize: userCount,
                                    }}
                                    className={`link-info me-2`}
                                  >
                                    <img
                                      src={viewIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </Link>
                                </Tippy>
                                {loginBranch?.auto_approve &&
                                  loginBranch?.branch_id === v.branch_id &&
                                  v.is_active === 1 && (
                                    <Tippy content="Approve">
                                      <a
                                        href="#approve"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          ApprovedBranch(v.challan_rtn_id);
                                        }}
                                        className="link-info"
                                      >
                                        {actionLoading === v.challan_rtn_id ? (
                                          <span className="spinner-border spinner-border-sm me-2"></span>
                                        ) : (
                                          <FcApproval size={24} />
                                        )}
                                      </a>
                                    </Tippy>
                                  )}

                                {/* <Tippy content="Print">
                                  <a
                                    href={
                                      v?.pdf_url ||
                                      `http://172.105.42.161:3015/pdf/${v.challan_rtn_id}.pdf`
                                    }
                                    className="me-2"
                                    target="_blank">
                                    <img
                                      src={printIcon}
                                      className="img-fluid"
                                      alt=""
                                    />
                                  </a>
                                </Tippy> */}
                                {/*{moment(v.trans_date).format("MM-DD-yy") >= moment().format("MM-DD-yy") && user.role_id !== 2 && (<>
                                                    <Tippy content="Cancel">
                                                        <a
                                                            href="#cancel"
                                                            onClick={(e) => changeStatus(v.challan_rtn_id, 0)}
                                                            className={`link-info ${v.is_active ? "" : "d-none"}`}
                                                        >
                                                            <img
                                                                src={deleteIcon}
                                                                className="img-fluid me-2"
                                                                alt=""
                                                            />
                                                        </a>
                                                    </Tippy>
                                                </>)}*/}

                                {user?.role_id !== 2 && (
                                  <>
                                    {moment(v.trans_date).format("MM-DD-yy") >=
                                      moment().format("MM-DD-yy") &&
                                      (v.is_active === 5 ||
                                        v.is_active === 2) && (
                                        <Tippy content="Edit">
                                          <Link
                                            to={
                                              `/challanRtn/edit/` +
                                              v.challan_rtn_id
                                            }
                                            state={{
                                              challanRtn: v,
                                              currentPageNo: currentPage,
                                              currentFilter: formInputs,
                                              showFilter: filtersVisible,
                                              pageSize: userCount,
                                            }}
                                            className={`link-info me-2`}
                                          >
                                            <img
                                              src={editIcon}
                                              className="img-fluid"
                                              alt=""
                                            />
                                          </Link>
                                        </Tippy>
                                      )}
                                  </>
                                )}
                              </td>
                            </tr>
                            <tr
                              key={`sli_` + i}
                              id={`sli_` + i}
                              className="d-none"
                            >
                              <td colSpan="7">
                                <div className="table-responsive">
                                  <table className="table table-sm table-bordered ms-auto w-50 py-0 mb-0">
                                    <thead>
                                      <tr style={{ textAlign: "center" }}>
                                        <th>#</th>
                                        <th>Item Name</th>
                                        <th>Rate</th>

                                        <th> Qty</th>
                                        <th>Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {v?.challan_dtl &&
                                        v.challan_dtl?.map((v, i) => (
                                          <tr key={`slil_` + i}>
                                            <td>{i + 1}</td>
                                            <td>{v?.mst_item?.item_name}</td>
                                            <td className="text-end">
                                              {millionComma(v.rate)}
                                            </td>
                                            <td className="text-end">
                                              {parseFloat(v?.qty || 0).toFixed(
                                                2,
                                              )}
                                            </td>

                                            <td className="text-end">
                                              {millionComma(v?.rate * v?.qty) ||
                                                millionComma(v?.amount)}
                                            </td>
                                          </tr>
                                        ))}

                                      <tr>
                                        <td
                                          colSpan="4"
                                          className="text-end pe-2 fw-bold"
                                        >
                                          Gross Total
                                        </td>
                                        <td className="fw-bold text-end">
                                          {formatAmountChallanRtn(v)}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                          </>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / userCount)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default ChallanRtnList;
